import { create } from "zustand";
import { persist } from "zustand/middleware";

import { createLegacyStorage, syncAcrossTabs } from "./legacyStorage";

const KEYS = [
  "userAuth",
  "refreshToken",
  "shouldChangePassword",
  "permissionCategories",
];

const useAuthStore = create(
  persist(
    set => ({
      userAuth: undefined,
      refreshToken: undefined,
      shouldChangePassword: undefined,
      permissionCategories: undefined,
      setUserAuth: userAuth => set({ userAuth }),
      updateUserAuth: patch =>
        set(s => (s.userAuth ? { userAuth: { ...s.userAuth, ...patch } } : {})),
      setRefreshToken: refreshToken => set({ refreshToken }),
      clearRefreshToken: () => set({ refreshToken: undefined }),
      setShouldChangePassword: shouldChangePassword =>
        set({ shouldChangePassword }),
      clearShouldChangePassword: () => set({ shouldChangePassword: undefined }),
      setPermissionCategories: permissionCategories =>
        set({ permissionCategories }),
      // Logout clears only userAuth and refreshToken; permissionCategories
      // and shouldChangePassword intentionally survive, matching the legacy
      // clearCredentials behavior.
      clearAuth: () => set({ userAuth: undefined, refreshToken: undefined }),
    }),
    { name: "auth", storage: createLegacyStorage(KEYS) }
  )
);

syncAcrossTabs(useAuthStore, KEYS);

export default useAuthStore;
